import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NetworksBarComponent } from './networks-bar.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NetworksBarComponent],
  exports: [NetworksBarComponent],
  entryComponents: [NetworksBarComponent]
})
export class NetworksBarModule { }
